import { 
    dashboardLabel, academyLabel, achievementsLabel, activityLabel, loginLabel, selectLanguageLabel, selectOrganizationLabel,
    usernameLabel, passwordLabel, createPasswordLabel, setPasswordLabel, onboardIntroText,
    onboardInvalidText, onboardInvalidIntroText, welcomeLabel, welcomeIntroLabel, completedCoursesLabel,
    completedOutOfLabel, goToAcademyLabel, latestActivityLabel,
    viewYourAchievementsLabel, academyIntroTextDashboardLabel, simulationSummaryLabel,
    simulationSummaryIntroTextDashboardLabel, phishingAttemptsReportedLabel, phishingAttemptsFailedLabel,
    outOfLabel,chapterTextLabel, modulesCompletedLabel, totalLabel, inProgressLabel, continueLearningLabel,
    signOutLabel, academyIntroTextLabel, achievementsIntroTextLabel, badgesLabel, badgesNoTextLabel,
    levelScoreLabel, recentActivityLabel, recentActivityIntroTextLabel, activeDaysLabel, latestActivityLogLabel,
    noActivityAvailableForLabel, noActivityAvailableLabel, yetLabel, levelUpLabel, levelLabel, activityIntroTextLabel,
    skipLabel, takeQuizLabel, videoLabel, nextQuestionLabel, quizLabel, questionLabel, completeLabel, nextChapterLabel, 
    continueLabel, submitLabel, expPointsGainedLabel, expPointsGainedCorrectAnswerLabel, introLabel, passwordsMatchLabel,
    confirmPasswordLabel, activityLogLabel, warningEmailsLabel, falseEmailsContentLabel, falseEmailsTitleLabel,
    incorrectUserOrPasswordLabel, chapterItemLabel, falseEmailsContentItemLabel, websiteLabel, previousLabel, nextLabel,
    organizationsLabel, usersLabel, reportsLabel, reportsIntroTextLabel, settingsLabel, viewAllLabel
} from "../utils/constants"

export const menuLabels = {
    [dashboardLabel]: {
        "EN": "Dashboard",
        "RU": "Главная",
        "NL": "Dashboard"
    },
    [organizationsLabel]: {
        "EN": "Organizations",
        "RU": "Организации",
        "NL": "Organisaties"
    },
    [usersLabel]: {
        "EN": "Users",
        "RU": "Пользователи",
        "NL": "Gebruikers"
    },
    [settingsLabel]: {
        "EN": "Settings",
        "RU": "Настройки",
        "NL": "Instellingen"
    },
    [reportsLabel]: {
        "EN": "Reports",
        "RU": "Отчеты",
        "NL": "Verslagen"
    },
    [academyLabel]: {
        "EN": "Academy",
        "RU": "Академия",
        "NL": "Academy"
    },
    [warningEmailsLabel]: {
        "EN": "Phishnoo Radar",
        "RU": "Радар Phishnoo",
        "NL": "Phishnoo Radar"
    },
    [achievementsLabel]: {
        "EN": "Achievements",
        "RU": "Достижения",
        "NL": "Prestaties"
    },
    [activityLabel]: {
        "EN": "Activity",
        "RU": "Деятельность",
        "NL": "Activiteit"
    },
    [loginLabel]: {
        "EN": "Login",
        "RU": "Вход",
        "NL": "Inloggen"
    },
    [selectLanguageLabel]: {
        "EN": "Select System Language",
        "RU": "Выберите язык системы",
        "NL": "Systeemtaal Kiezen"
    },
    [selectOrganizationLabel]: {
        "EN": "Select Organization to Manage",
        "RU": "Выберите организацию для управления",
        "NL": "Selecteer organisatie om te beheren"
    }
} as const;

export const sysLabels = {
    [websiteLabel]: {
        "EN": "Phishnoo.com",
        "RU": "Phishnyet.by",
        "NL": "Phishnoo.com/nl"
    },
    [usernameLabel]: {
        "EN": "Username",
        "RU": "Имя пользователя",
        "NL": "Gebruikersnaam"
    },
    [passwordLabel]: {
        "EN": "Password",
        "RU": "Пароль",
        "NL": "Wachtwoord"
    },
    [createPasswordLabel]: {
        "EN": "Create New Password",
        "RU": "Создать новый пароль",
        "NL": "Nieuw wachtwoord aanmaken"
    },
    [setPasswordLabel]: {
        "EN": "Save Password",
        "RU": "Сохранить пароль",
        "NL": "Wachtwoord opslaan"
    },
    [onboardIntroText]: {
        "EN": "Welcome to your new Phishnoo Academy account. Before we get started, please create a password to secure your account.",
        "RU": "Добро пожаловать в вашу новую учетную запись Phishnoo Academy. Прежде чем приступить к работе, пожалуйста, создайте пароль для защиты вашей учетной записи.",
        "NL": "Welkom bij uw nieuwe Phishnoo Academy-account. Voordat we beginnen, dient u een wachtwoord aan te maken om uw account te beveiligen."
    },
    [onboardInvalidText]: {
        "EN": "Code Is Invalid",
        "RU": "Код недействителен",
        "NL": "Uw Code Is Verlopen"
    },
    [onboardInvalidIntroText]: {
        "EN": "The code that you have tried to use has either been deleted or is incorrect.",
        "RU": "Код, который вы пытались использовать, был удален или является неверным.",
        "NL": "De code die u hebt geprobeerd te gebruiken, is verwijderd of onjuist."
    },
    [welcomeLabel]: {
        "EN": "Welcome",
        "NL": "Welkom",
        "RU": "Добро пожаловать"
    },
    [welcomeIntroLabel]: {
        "EN": "Together we will build a Human Firewall.",
        "NL": "Samen bouwen we een Menselijke Firewall.",
        "RU": "Вместе мы создадим человеческий брандмауэр."
    },
    [completedCoursesLabel]: {
        "EN": "Completed Courses",
        "NL": "Voltooide cursussen",
        "RU": "Завершенные курсы"
    },
    [completedOutOfLabel]: {
        "EN": "completed out of",
        "NL": "voltooid van de ",
        "RU": "выполнено из"
    },
    [academyLabel]: {
        "EN": "Academy",
        "RU": "Академия",
        "NL": "Academy"
    },
    [activityLabel]: {
        "EN": "Activity",
        "RU": "Деятельность",
        "NL": "Activiteit"
    },
    [goToAcademyLabel]: {
        "EN": "Go to the Academy",
        "RU": "Перейти в Академию",
        "NL": "Ga naar de Academy"
    },
    [viewAllLabel]: {
        "EN": "View All",
        "RU": "Показать все",
        "NL": "Alles bekijken"
    },
    [achievementsLabel]: {
        "EN": "Achievements",
        "RU": "Достижения",
        "NL": "Prestaties"
    },
    [viewYourAchievementsLabel]: {
        "EN": "View Your Achievements",
        "RU": "Просмотр ваших достижений",
        "NL": "Bekijk je prestaties"
    },
    [latestActivityLabel]: {
        "EN": "Latest Activity",
        "RU": "Последние действия",
        "NL": "Laatste activiteit"
    },
    [academyIntroTextDashboardLabel]: {
        "EN": "A quick look at the next module waiting for you to complete.",
        "RU": "Краткий обзор следующего модуля, который ждет вас.",
        "NL": "Een snelle blik op de volgende module die op je wacht om te voltooien."
    },
    [simulationSummaryLabel]: {
        "EN": "Simulation Summary",
        "RU": "Резюме моделирования",
        "NL": "Simulatieoverzicht"
    },
    [simulationSummaryIntroTextDashboardLabel]: {
        "EN": "Your latest simulation statistics for the last 30 days.",
        "RU": "Ваша последняя статистика симуляций за последние 30 дней.",
        "NL": "Uw meest recente simulatiestatistieken voor de afgelopen 30 dagen."
    },
    [phishingAttemptsReportedLabel]: {
        "EN": "Phishing Attemps Reported",
        "RU": "Сообщения о попытках фишинга",
        "NL": "Gemelde pogingen tot phishing"
    },
    [phishingAttemptsFailedLabel]: {
        "EN": "Phishing Attemps Failed",
        "RU": "Попытки фишинга не удались",
        "NL": "Mislukte Phishing pogingen"
    },
    [outOfLabel]: {
        "EN": "out of",
        "RU": "из",
        "NL": "van de"
    },
    [chapterTextLabel]: {
        "EN": "Chapter",
        "RU": "Глава",
        "NL": "Hoofdstuk"
    },
    [modulesCompletedLabel]: {
        "EN": "modules completed",
        "RU": "завершенные модули",
        "NL": "voltooide modules"
    },
    [inProgressLabel]: {
        "EN": "in progress",
        "RU": "в процессе",
        "NL": "in uitvoering"
    },
    [totalLabel]: {
        "EN": "total",
        "RU": "всего",
        "NL": "totaal"
    },
    [continueLearningLabel]: {
        "EN": "Continue Learning",
        "RU": "Продолжить обучение",
        "NL": "Blijf leren"
    },
    [signOutLabel]: {
        "EN": "Logout",
        "RU": "Выход",
        "NL": "Uitloggen"
    },
    [academyIntroTextLabel]: {
        "EN": "Training to build a strong Human Firewall.",
        "RU": "Образование, которое поможет вам стать человеческим брандмауэром.",
        "NL": "Training om samen een Menselijke Firewall te creëren."
    },
    [achievementsIntroTextLabel]: {
        "EN": "Your score, badges, and level show your progress in defending against Phishing and Social Engineering hackers. Together, we'll fight back and build a Human Firewall.",
        "RU": "Ваш балл, значки и уровень показывают ваши навыки и опыт в защите от фишинга и хакеров, использующих методы социальной инженерии. Вы можете с гордостью демонстрировать свой уровень как часть своей профессиональной карьеры. Вы также сможете получить доступ к преимуществам и наградам.",
        "NL": "Je score, badges en niveau tonen de voortgang van je vaardigheden in het verdedigen tegen Phishing en Social Engineering hackers. Samen gaan we de strijd aan en bouwen we een Menselijke Firewall"
    },
    [badgesLabel]: {
        "EN": "Badges",
        "RU": "Значки",
        "NL": "Badges"
    },
    [badgesNoTextLabel]: {
        "EN": "You have not achieved any badges yet. Complete more chapters and modules to collect more.",
        "RU": "Вы еще не получили ни одного значка. Пройдите больше глав и модулей, чтобы собрать больше значков.",
        "NL": "Je hebt nog geen badges behaald. Voltooi meer hoofdstukken en modules om er meer te verzamelen."
    },
    [levelScoreLabel]: {
        "EN": "Level & Score",
        "RU": "Уровень и оценка",
        "NL": "Niveau & Score"
    },
    [recentActivityLabel]: {
        "EN": "Recent Activity",
        "RU": "Последние действия",
        "NL": "Recente activiteit"
    },
    [recentActivityIntroTextLabel]: {
        "EN": "This is a history of your latest activity which adds to your overall score and achievements. Keep completing tasks, reporting phishing emails and avoiding phishning attempts in order to grow your score and gain higher levels.",
        "RU": "Это история вашей последней активности, которая добавляется к вашему общему баллу и достижениям. Продолжайте выполнять задания, сообщать о фишинговых письмах и избегать попыток фишинга, чтобы повысить свой балл и перейти на более высокие уровни.",
        "NL": "Dit is een overzicht van uw laatste activiteiten die bijdragen aan uw totale score en prestaties. Blijf taken voltooien, phishing-e-mails melden en phishing-pogingen vermijden om uw score te verhogen en hogere niveaus te bereiken."
    },
    [activeDaysLabel]: {
        "EN": "active days this year",
        "RU": "активные дни в этом году",
        "NL": "actieve dagen dit jaar"
    },
    [latestActivityLogLabel]: {
        "EN": "Latest Activity Log",
        "RU": "Журнал последних действий",
        "NL": "Laatste activiteitenlogboek"
    },
    [activityLogLabel]: {
        "EN": "Activity Log",
        "RU": "последних действий",
        "NL": "Activiteitenlogboek"
    },
    [noActivityAvailableForLabel]: {
        "EN": "No Activities Available for",
        "RU": "Нет доступных мероприятий для",
        "NL": "Geen activiteiten beschikbaar voor"
    },
    [noActivityAvailableLabel]: {
        "EN": "No Activities Available",
        "RU": "Нет доступных мероприятий",
        "NL": "Geen activiteiten beschikbaar"
    },
    [yetLabel]: {
        "EN": "yet",
        "RU": "Пока нет",
        "NL": "er zijn nog"
    },
    [levelUpLabel]: {
        "EN": "experience points until levelling up!",
        "RU": "очка опыта до повышения уровня!",
        "NL": "ervaringspunten tot je een niveau hoger komt!"
    },
    [levelLabel]: {
        "EN": "Lvl",
        "RU": "Урв",
        "NL": "Lvl"
    },
    [activityIntroTextLabel]: {
        "EN": "This is a summary table of your latest overall activity and activity over time.",
        "RU": "Это сводная таблица вашей последней общей активности и активности за определенный период времени.",
        "NL": "Dit is een overzichtstabel van uw laatste algemene activiteiten en activiteiten in de loop van de tijd."
    },
    [skipLabel]: {
        "EN": "Skip",
        "RU": "Пропустить",
        "NL": "Overslaan"
    },
    [takeQuizLabel]: {
        "EN": "Take the Quiz",
        "RU": "Пройдите тест",
        "NL": "Doe de quiz"
    },
    [videoLabel]: {
        "EN": "Video",
        "RU": "Видео",
        "NL": "Video"
    },
    [nextQuestionLabel]: {
        "EN": "Next Question",
        "RU": "Следующий вопрос",
        "NL": "Volgende vraag"
    },
    [quizLabel]: {
        "EN": "Quiz",
        "RU": "Викторина",
        "NL": "Quiz"
    },
    [questionLabel]: {
        "EN": "Question",
        "RU": "Вопрос",
        "NL": "Vraag"
    },
    [completeLabel]: {
        "EN": "Complete",
        "RU": "Завершить",
        "NL": "Voltooid"
    },
    [chapterItemLabel]: {
        "EN": "Chapter",
        "RU": "глава",
        "NL": "Hoofdstuk"
    },
    [nextChapterLabel]: {
        "EN": "Next Chapter",
        "RU": "Следующая глава",
        "NL": "Volgend hoofdstuk"
    },
    [continueLabel]: {
        "EN": "Continue",
        "RU": "Продолжить",
        "NL": "Doorgaan"
    },
    [submitLabel]: {
        "EN": "Submit",
        "RU": "Oтправить",
        "NL": "Indienen"
    },
    [expPointsGainedLabel]: {
        "EN": "Experience Points Gained!",
        "RU": "Получены очки опыта!",
        "NL": "Ervaringspunten verdiend!"
    },
    [expPointsGainedCorrectAnswerLabel]: {
        "EN": "Experiences Points Gained for a Correct Answer!",
        "RU": "Очки опыта, полученные за правильный ответ!",
        "NL": "Ervaringspunten verdiend voor een juist antwoord!"
    },
    [introLabel]: {
        "EN": "Introduction",
        "RU": "Введение",
        "NL": "Inleiding"
    },
    [confirmPasswordLabel]: {
        "EN": "Confirm Password",
        "RU": "Подтвердите пароль",
        "NL": "Wachtwoord bevestigen"
    },
    [passwordsMatchLabel]: {
        "EN": "Passwords Do Not Match",
        "RU": "Пароли не совпадают",
        "NL": "Wachtwoorden komen niet overeen"
    },
    [incorrectUserOrPasswordLabel]: {
        "EN": "Email/Username or Password is Incorrect",
        "RU": "Неверный адрес электронной почты/имя пользователя или пароль",
        "NL": "E-mailadres/gebruikersnaam of wachtwoord is onjuist"
    },
    [falseEmailsTitleLabel]: {
        "EN": "Phishnoo Radar",
        "RU": "Радар Phishnoo",
        "NL": "Phishnoo Radar"
    },
    [falseEmailsContentLabel]: {
        "EN": "Every report from our users powers Phishnoo Radar, turning real phishing emails into a constantly updated collection of current threats.",
        "RU": "Каждое сообщение имеет значение! Phishnoo Radar получает информацию от пользователей и предоставляет актуальный обзор реальных фишинговых атак.",
        "NL": "Iedere melding telt! Phishnoo Radar wordt gevoed door meldingen van gebruikers en geeft een actueel overzicht van echte phishingaanvallen."
    },
    [falseEmailsContentItemLabel]: {
        "EN": "This phishing email was intercepted by Phishnoo Radar. Take a look and learn from it, because forewarned is forearmed!",
        "RU": "Это фишинговое письмо было перехвачено Phishnoo Radar. Ознакомьтесь с ним, чтобы извлечь из него уроки, ведь предупрежден — значит вооружен!",
        "NL": "Deze phishingmail is door Phishnoo Radar onderschept. Neem een kijkje om ervan te leren, want een gewaarschuwd mens telt voor twee!"
    },
    [previousLabel]: {
        "EN": "Previous",
        "RU": "Назад",
        "NL": "Terug"
    },
    [nextLabel]: {
        "EN": "Next",
        "RU": "Следующий",
        "NL": "Verder"
    },
    [reportsLabel]: {
        "EN": "Reports",
        "RU": "Отчеты",
        "NL": "Verslagen"
    },
    [reportsIntroTextLabel]: {
        "EN": "You currently have no data available for this organization. Please allow up to 30 days for data reports to process.",
        "RU": "В настоящее время для этой организации нет доступных данных. Обработка отчетов с данными займет 30 дней.",
        "NL": "Er zijn momenteel geen gegevens beschikbaar voor deze organisatie. Het kan tot 30 dagen duren voordat de gegevensrapporten zijn verwerkt."
    },
    [organizationsLabel]: {
        "EN": "Organizations",
        "RU": "Организации",
        "NL": "Organisaties"
    },
    [usersLabel]: {
        "EN": "Users",
        "RU": "Пользователи",
        "NL": "Gebruikers"
    },
    [settingsLabel]: {
        "EN": "Settings",
        "RU": "Настройки",
        "NL": "Instellingen"
    }
}
